import React, { Component } from "react";

import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
interface PopupProps { // Added this interface for props
  toggle: any
}
export default class UserRolePopup extends Component<PopupProps> {

  handleClick = () => {
    this.props.toggle();
  };

  render() {
    return (
      <Modal isOpen toggle={this.handleClick.bind(this)}>
        <ModalHeader toggle={this.handleClick.bind(this)} data-cy="aidasProjectPropertyDeleteDialogHeading">
          Confirm delete operation
        </ModalHeader>
        <ModalBody id="ainnotategwApp.ainnotateserviceAidasProjectProperty.delete.question">
          Are you sure you want to delete this AidasProjectProperty?
        </ModalBody>
        <ModalFooter>
        </ModalFooter>
      </Modal>
  );
  }
}
